/**
 * 图表复权 dataType → WS/HTTP candleMode（0 不复权→1，1 前复权→2）。
 * @param {number|undefined} dataType
 * @returns {number}
 */
export function resolveStockKlineCandleMode(dataType) {
  return Number(dataType) === 1 ? 2 : 1;
}
